module.exports = __webpack_public_path__ + "img/houseactivetwo.ea9e9eef.svg";